// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
const ReactPopper = require('react-popper')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const WindowResizeListener = require('client-v2/common/components/window-resize-listener')
// Sibling imports
const TooltipBubble = require('./bubble')

/**
 * @TODO Refactor this to use `client-v2/common/components/popper-anchor.js`
 */
function TooltipAnchor(props) {
  let { modifiers, placement } = props
  if (Array.isArray(placement)) {
    // Treat multiple placements as preferred flip behavior
    modifiers = {
      ...modifiers,
      flip: {
        behavior: placement
      }
    }
    placement = placement[0]
  }
  return tag(ReactPopper.Manager,
    tag(ReactPopper.Reference,
      ({ ref }) => {
        const child = React.Children.only(props.children)
        // This ref is intended for a DOM element
        const refKey = typeof child.type === 'string' ? 'ref' : 'forwardedRef'
        return React.cloneElement(child, {
          [refKey]: ref
        })
      }
    ),
    Portal.toModalRoot(
      tag(ReactPopper.Popper, {
        modifiers,
        placement
      },
        (popperProps) => (
          tag(TooltipBubble, {
            arrowRef: popperProps.arrowProps.ref,
            arrowStyle: popperProps.arrowProps.style,
            popperPlacement: popperProps.placement,
            popperRef: popperProps.ref,
            popperStyle: popperProps.style,
            tooltipKey: props.tooltipKey,
            isDismissed: props.isDismissed,
            onDismiss: props.onDismiss
          },
            tag(WindowResizeListener, {
              animate: true,
              timeout: props.updateAfterResizeDelay,
              onResize: popperProps.scheduleUpdate
            }),
            props.renderBubbleChildren()
          )
        )
      )
    )
  )
}

TooltipAnchor.propTypes = {
  children: PropTypes.node,
  // Popper options
  modifiers: PropTypes.object,
  placement: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  // Values
  isDismissed: PropTypes.bool,
  tooltipKey: PropTypes.string,
  updateAfterResizeDelay: PropTypes.number,
  // Render props
  renderBubbleChildren: PropTypes.func.isRequired,
  // Callbacks
  onDismiss: PropTypes.func
}

module.exports = TooltipAnchor
